export const SelectButton = ({ selected, onClick, disabled, children }) => (
  <button
    onClick={onClick}
    className={`px-2 sm:px-3 py-1 sm:py-1.5 text-xs sm:text-sm rounded-md transition-all ${
      selected
        ? "bg-blue-600 text-white font-medium shadow-sm"
        : "bg-gray-50 text-gray-700 border border-gray-200 hover:bg-gray-100"
    } ${disabled ? "opacity-50 cursor-not-allowed" : ""}`}
    disabled={disabled}
  >
    {children}
  </button>
);
